import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../charts/PieChart'
import { useGetAppAppVersionQuery, useGetAppSdkVersionQuery, useGetAppVersionPerDayQuery } from '../../../api/appApiSlice';
import BlockChart from '../../BlockChart';
import versionCompare from '../../../services/versionCompare';

const DevicePerAppVersion = ({appId, filter, ...props}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isLoading, refetch } = useGetAppAppVersionQuery({appId, filter})
  const pieData = [...data].sort((a,b) => versionCompare(b.app_version,a.app_version) ).map((x)=>({"name":x.app_version,"y":x.active_devices}))

  return (
    <BlockChart title={t('version.device_per_app_version')} isSuccess={isSuccess} isLoading={isLoading} retry={refetch} {...props}>
      <PieChart data={pieData} legendOptions={{show: false}} datalabels/>
    </BlockChart>
  )
}

export default DevicePerAppVersion